import React from "react";
import { Info } from "lucide-react";

// Visually-distinct banner shown at the TOP of an assistant message when the agent committed
// to an interpretation via the state_assumption tool (B-AMB-1: default-commit + state-assumption).
//
// Amber tone deliberately distinct from WebSourceBlock's blue (web-derived content) and from
// error red — it signals "important context, not a problem".
//
// Props:
//   assumption.text      : string — the assumption itself
//   assumption.rationale : string (optional) — why this interpretation was chosen

export default function AssumptionBanner({ assumption }) {
  if (!assumption || !assumption.text) return null;
  return (
    <div className="my-2 p-3 border-l-4 border-amber-400 bg-amber-50 rounded text-sm">
      <div className="flex items-center gap-2 text-xs text-amber-700 font-medium mb-1">
        <Info className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={2} />
        Proceeding with assumption
      </div>
      <p className="text-gray-800">{assumption.text}</p>
      {assumption.rationale && (
        <p className="mt-1 text-xs text-gray-600 italic">{assumption.rationale}</p>
      )}
    </div>
  );
}
